import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const TextAreaModal = (props) => {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <div className="py-1">
        <Modal.Body>
          <h6 className="mb-2">Special request to provider below (if any) :</h6>
          <textarea
            placeholder="Example: Please also test for diabetes"
            className="form-control"
            id="customTextInput"
            value={props?.value}
            onChange={props?.handleInputChange}
            rows="4"
            style={{
              padding: "5px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </Modal.Body>

        <div className="flex items-center p-[16px] gap-2 justify-end w-full">
          <button
            className="text-black py-[11px] w-fit px-4 !border !border-slate-400 !rounded-md text-base font-medium"
            onClick={props?.onHide}
          >
            <p className="!mb-0 text-sm">Cancel</p>
          </button>
          <button
            className="sign_btn py-[6px] !w-fit px-4 text-white text-base font-medium whitespace-nowrap"
            onClick={props?.handleSubmit}
          >
            {props?.loading ? (
              <Spinner animation="border" variant="white" />
            ) : (
              <p className="!mb-0 text-sm">Confirm and Pay</p>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default TextAreaModal;
